import { makeVar } from '@apollo/client';
import { ConnectionStatusType } from '@/components/connection-status/connection-status-type.ts';

export const websocketStatusVar = makeVar<ConnectionStatusType | null>(null);
